import { render, staticRenderFns } from "./PurchaseDocuments.vue?vue&type=template&id=6a0f167a&scoped=true"
import script from "./PurchaseDocuments.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocuments.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseDocuments.vue?vue&type=style&index=0&id=6a0f167a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f167a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0f167a')) {
      api.createRecord('6a0f167a', component.options)
    } else {
      api.reload('6a0f167a', component.options)
    }
    module.hot.accept("./PurchaseDocuments.vue?vue&type=template&id=6a0f167a&scoped=true", function () {
      api.rerender('6a0f167a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseDocuments.vue"
export default component.exports